<cosmos-section
  [loading]="(_loading$ | async) === true"
>
  <div class="cosmos-users__table__wrapper">
    <cosmos-table
      [columns]="_columns"
      [dataSource]="_dataSource"
      [hasSearchbar]="true"
      [hasDropdownFilter]="true"
      [controlPanelTemplate]="usersControls"
      [isDownloading]="(_downloadingCSV$ | async) || false"
      (clickedRow)="onTableRowClick($event)"
      class="cosmos-users__table"
    >
    </cosmos-table>
  </div>
</cosmos-section>

<ng-template #usersControls>
  <div class="cosmos-users__control-panel">
    <button
      (click)="exportFiltered()"
      class="cosmos-users__control-panel__export-filtered-button"
    >
      Export Filtered CSV
    </button>
    <button
      (click)="exportAll()"
      class="cosmos-users__control-panel__export-button"
    >
      Export CSV
    </button>
  </div>
</ng-template>
